import { APICore } from "./apiCore";

const api = new APICore();

/** Lista checklists da unidade */
const listarChecklists = () => {
  return api.get("/checklist-relatorio-parcial");
};

/** Detalhe de um checklist (com opções) */
const obterChecklistPorId = (id: string | number) => {
  return api.get(`/checklist-relatorio-parcial/${id}`);
};

/** Cria item de checklist */
const criarChecklist = (params: {
  descricao: string;
  ordem?: number;
  ativo?: boolean;
}) => {
  return api.create("/checklist-relatorio-parcial", params);
};

/** Atualiza item de checklist */
const atualizarChecklist = (
  id: string | number,
  params: { descricao?: string; ordem?: number; ativo?: boolean }
) => {
  return api.update(`/checklist-relatorio-parcial/${id}`, params);
};

/** Exclui item de checklist */
const excluirChecklist = (id: string | number) => {
  return api.delete(`/checklist-relatorio-parcial/${id}`);
};

/** Lista opções de um checklist */
const listarOpcoes = (checklistId: string | number) => {
  return api.get(
    `/checklist-relatorio-parcial-opcao/checklist/${checklistId}/opcoes`
  );
};

/** Cria opção (body: checklist_relatorio_parcial_id, descricao, ordem) */
const criarOpcao = (params: {
  checklist_relatorio_parcial_id: number;
  descricao: string;
  ordem?: number;
}) => {
  return api.create("/checklist-relatorio-parcial-opcao", params);
};

/** Exclui opção */
const excluirOpcao = (id: string | number) => {
  return api.delete(`/checklist-relatorio-parcial-opcao/${id}`);
};

export {
  listarChecklists,
  obterChecklistPorId,
  criarChecklist,
  atualizarChecklist,
  excluirChecklist,
  listarOpcoes,
  criarOpcao,
  excluirOpcao,
};
